module.exports = __webpack_public_path__ + "img/7-2.55236725.png";